import React, { useState } from 'react'

const SaveFile = () => {

    const [file, setFile] = useState(null);
    const {status, setStatus} = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(!file){
            setStatus("Veuillez sélectionner un fichier.");
            return;
        }

        const formData = new FormData();
        formData.append("fichier",file);
        console.log(formData);
    }

  return (
    <div className='container'>
        <form onSubmit={handleSubmit}>

            <div className='mb-3'>
            <label htmlFor="fichier" className='form-label'>Selectionnez un fichier</label>
            <input type="file" className='form-control' id="fichier" name='fichier' 
            
            accept="application/pdf,image/*"
            onChange={(e) => setFile(e.target.files[0])}

            required

            />

            </div>
            <button type="submit" className='btn btn-primary'>Envoyer</button>
            
        </form>

    </div>
  )
}

export default SaveFile
